export default __webpack_public_path__ + "47c7b1dbb5879333e6934cd48b919ae5.jpg";